import RecoverPwdLanding from './styled';

export default RecoverPwdLanding;
